import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const MapPinIcon = props => {
  return (
    <Svg
      width={18}
      height={21}
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 9a4.75 4.75 0 119.5 0 4.75 4.75 0 01-9.5 0zM9 5.75a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5z"
        fill="#3876AA"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.524 7.857A8.288 8.288 0 018.784.25h.432a8.288 8.288 0 018.26 7.607 8.944 8.944 0 01-1.99 6.396l-4.793 5.861a2.187 2.187 0 01-3.386 0l-4.793-5.861a8.943 8.943 0 01-1.99-6.396zm8.26-6.107A6.788 6.788 0 002.02 7.98a7.443 7.443 0 001.656 5.323l4.793 5.862a.687.687 0 001.064 0l4.793-5.862A7.443 7.443 0 0015.98 7.98a6.788 6.788 0 00-6.765-6.23h-.432z"
        fill="#3876AA"
      />
    </Svg>
  );
};

export default MapPinIcon;
